
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leistungen/[leistung]",
      function () {
        return require("private-next-pages/leistungen/[leistung].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leistungen/[leistung]"])
      });
    }
  